import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { UserQuery } from '@examdojo/user';
import { map, of, switchMap } from 'rxjs';

import { getQuestionDifficulty, QuestionEntityState, QuestionEntityStoreModel, QuestionEntityUIModel } from './models';
import { QuestionEntityStore } from './question.store';

@Injectable({ providedIn: 'root' })
export class QuestionEntityQuery extends QueryEntity<
  QuestionEntityState,
  QuestionEntityStoreModel,
  QuestionEntityUIModel,
  'id'
> {
  constructor(
    protected override readonly store: QuestionEntityStore,
    private readonly userQuery: UserQuery,
  ) {
    super(
      store,
      () => [this.userQuery.entities$],
      (id) => [
        this.selectEntity(id).pipe(
          map((entity) => entity?.question.authorId),
          switchMap((authorId) => (authorId ? this.userQuery.selectEntity(authorId) : of(null))),
        ),
      ],
    );
  }

  override toUIModelFn = (entity: QuestionEntityStoreModel): QuestionEntityUIModel => {
    return {
      ...entity,
      question: {
        ...entity.question,
        author: entity.question.authorId ? this.userQuery.getUIEntity(entity.question.authorId) : null,
        difficulty: getQuestionDifficulty(entity.question),
      },
    };
  };
}
